import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Spinner from "../common/Spinner";
import { standardisePoint } from "../../api/routeUtilitiesApi";
import { simplifyPath } from "../../api/douglaspeucker";

const UploadRouteControl = ({
    onUpload,
    onCancel,
    warningMessage,
    errors = {}
}) => {

    const [processing, setProcessing] = useState(false);
    const [uploadLabel, setUploadLabel] = useState("Choose file...");
    const [hasFile, setHasFile] = useState(false);
    const [draftRoute, setDraftRoute] = useState(false);

    function onFileUpload(e) {
        setProcessing(true);
        var uploadInput = e.target;
        if ('files' in uploadInput) {
            if (uploadInput.files.length == 0) {
                return;
            } else {
                var file = uploadInput.files[0];
                setUploadLabel(file.name);

                
                var reader = new FileReader();

                reader.addEventListener('load', function (e) {
                    let gpx = e.target.result;
                    parseGpx(gpx);
                });

                reader.readAsBinaryString(file)

                setHasFile(true);
            }
        }
        else {
            if (uploadInput.value == "") {
                setUploadLabel("Select one or more files.");
            } else {
                setUploadLabel("The files property is not supported by your browser!");
            }
        }
    }

    function parseGpx(data) {

        let draftRouteData = [];

        let parser = new DOMParser();
        let gpxFile = parser.parseFromString(data, "text/xml");

        let trkpts = gpxFile.getElementsByTagName("trkpt");
        
        for (let i = 0; i < trkpts.length; i++) {
            let lat = parseFloat(trkpts[i].attributes.lat.value);
            let lng = parseFloat(trkpts[i].attributes.lon.value);

            let point = standardisePoint({ lat: lat, lng: lng });
            if (trkpts[i].getElementsByTagName("ele")[0]) {
                point.ele = parseFloat(trkpts[i].getElementsByTagName("ele")[0].innerHTML);
            }
                
            draftRouteData.push(point);
        }
        draftRouteData = simplifyPath(draftRouteData, 0.00003)
        setDraftRoute(draftRouteData)
        setProcessing(false)
    }

    function processUpload() {
        onUpload(draftRoute); 
    }

    return (
        processing ?
            <Spinner /> : (

            <form onSubmit={onUpload} className="">
                { warningMessage ? <div className="alert alert-warning mb-4" role="alert">{warningMessage}</div> : "" }
                <div className="form-group mt-02">
                    <div className="custom-file">
                        <input type="file" accept=".gpx" className="custom-file-input" id="routeUploadInput" onChange={onFileUpload} />
                        <label className="custom-file-label" htmlFor="routeUploadInput">{uploadLabel}</label>
                    </div>
                    </div>
                <button type="button" className="btn btn-info float-right ml-1 mt-4" disabled={!hasFile} onClick={processUpload}>Upload</button> 
                { onCancel ? <button type="button" className="btn btn-link float-right mt-4" onClick={onCancel}>Cancel</button> : ""} 
            </form>
        )
    );
}

UploadRouteControl.propTypes = {
    errors: PropTypes.object,
    onUpload: PropTypes.func.isRequired,
    onCancel: PropTypes.func
}

export default UploadRouteControl;


// WEBPACK FOOTER //
// ./src/components/routes/UploadRouteControl.js